import { useEffect } from "react";
import { pageTitle } from "../../helper";
import Div from "../Div";
import PageHeading from "../PageHeading";
import SectionHeading from "../SectionHeading";
import Spacing from "../Spacing";
import LogoList from "../LogoList";

export default function CaseStudyDetailsPage() {
  pageTitle("Case Study Details");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <PageHeading
        title="Our Partners"
        bgSrc="/images/contact_hero_bg.jpeg"
        pageLinkText="Our Partners"
      />

      <Spacing lg="140" md="80" />
      <Div className="container text-center">
        <Div className="row col-lg-10 offset-lg-1">
          <p className="cs-m5">
            We collaborate with telecommunications providers, government
            entities, global brands and institutional partners to deploy
            entertainment platforms at scale. Our approach combines product
            discipline, operational execution and long-term alignment.
          </p>
        </Div>
      </Div>
      {/* Start LogoList Section */}
      <Div className="container">
        <Spacing lg="50" md="25" />

        <Div className="partner-wrap">
          <SectionHeading
            title="Telco & Wallets"
            subtitle=""
            variant="cs-style1 text-center"
          />

          <Spacing lg="600" md="600" />
          <LogoList
            perRow={6}
            size={250}
            categories={["telco", "wallet"]}
          />
          <SectionHeading
            title="Brands & Others"
            subtitle=""
            variant="cs-style1 text-center"
          />
          <Spacing lg="600" md="600" />
          <LogoList
            perRow={6}
            size={250}
            categories={["brand", "other"]}
          />
        </Div>
      </Div>
      <Spacing lg="150" md="80" />
      {/* End LogoList Section */}
    </>
  );
}
